export const messages = {
  placeholder: { id: 'admin/promotions.form.selector.collections.placeholder' },
  label: { id: 'admin/promotions.form.selector.collections.label' },
}
